import { useSeo, SITE_URL } from "@/lib/seo";
import { breadcrumb } from "@/lib/structuredData";
import StartProjectForm from "@/components/StartProjectForm";
import { ShieldCheck, Compass, FileCheck2 } from "lucide-react";

const TRUST = [
  {
    icon: ShieldCheck,
    title: "Buyer-side NDA by default",
    body: "Every brief received is treated as confidential. We operate on the buyer's side of the transaction — factories never see your commercial context.",
  },
  {
    icon: Compass,
    title: "23 years on the floor",
    body: "1,000+ Indian factories personally vetted across lighting, furniture, home décor, textile and brass — headquartered inside the Moradabad brass cluster.",
  },
  {
    icon: FileCheck2,
    title: "One accountable point of contact",
    body: "From brief to container-load photograph — one team, transparent fee, no factory kickbacks. Documentation archived and delivered.",
  },
];

export const StartAProject = () => {
  useSeo({
    title: "Start Your Project · India Sourcing Brief · Asia Sourcing",
    description:
      "Submit a sourcing brief to Asia Sourcing — 23-year India sourcing house in Moradabad. Category, MOQ, target price, destination, timeline. NDA-first. One working day response.",
    path: "/start-a-project",
    type: "website",
    jsonLd: {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "WebPage",
          "@id": `${SITE_URL}/start-a-project#page`,
          name: "Start Your Project — Asia Sourcing",
          url: `${SITE_URL}/start-a-project`,
          description:
            "Submit a two-step India sourcing brief covering category, quantity, target price, destination and timeline. Buyer-side, confidential, response within one working day.",
        },
        breadcrumb([
          { name: "Home", path: "/" },
          { name: "Start Your Project", path: "/start-a-project" },
        ]),
      ],
    },
  });

  return (
    <article className="sp-page" data-testid="start-a-project-page">
      {/* HERO */}
      <header className="sp-page-hero">
        <div className="sp-page-hero-inner wrap">
          <p className="sp-page-eyebrow">Project intake</p>
          <h1 className="sp-page-h1">
            Source better. <br />
            Manufacture with confidence.
          </h1>
          <p className="sp-page-lede">
            Share a brief and our sourcing team will revert within one working day — typically with
            a factory shortlist, indicative FOB pricing and next steps for sampling. All information
            is treated as confidential under our buyer-side NDA policy.
          </p>
          <div className="sp-page-trust">
            {TRUST.map((t) => (
              <div key={t.title} className="sp-page-trust-tile">
                <t.icon size={18} strokeWidth={1.3} aria-hidden />
                <div>
                  <h3>{t.title}</h3>
                  <p>{t.body}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </header>

      {/* FORM */}
      <section className="sp-page-form-wrap">
        <div className="wrap">
          <StartProjectForm variant="page" />
        </div>
      </section>
    </article>
  );
};

export default StartAProject;
